import { useMemo } from "react";
import { DbItem, DbItemAny, dbObserveItem } from "~src/services/db";
import useObservable from "./useObservable";

export default function useDbItem<T extends DbItem = DbItemAny>(path: string, undefinedValue: T | undefined = undefined) {
	const ob = useMemo(() => (path ? dbObserveItem<T>(path) : undefined), [path]);
	const value = useObservable(ob);
	return value === undefined ? undefinedValue : value;
}